var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17C12.2239 17 12 17.2239 12 17.5C12 17.7761 12.2239 18 12.5 18H13.5C13.7761 18 14 17.7761 14 17.5C14 17.2239 13.7761 17 13.5 17H12.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.5C18 17.2239 18.2239 17 18.5 17H19.5C19.7761 17 20 17.2239 20 17.5C20 17.7761 19.7761 18 19.5 18H18.5C18.2239 18 18 17.7761 18 17.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17C15.2239 17 15 17.2239 15 17.5C15 17.7761 15.2239 18 15.5 18H16.5C16.7761 18 17 17.7761 17 17.5C17 17.2239 16.7761 17 16.5 17H15.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12 14.2239 12.2239 14 12.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7761 13.7761 15 13.5 15H12.5C12.2239 15 12 14.7761 12 14.5Z",
    fill: "#00112B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11C12.2239 11 12 11.2239 12 11.5C12 11.7761 12.2239 12 12.5 12H13.5C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11H12.5Z",
    fill: "#00112B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5C18 14.2239 18.2239 14 18.5 14H19.5C19.7761 14 20 14.2239 20 14.5C20 14.7761 19.7761 15 19.5 15H18.5C18.2239 15 18 14.7761 18 14.5Z",
    fill: "#00112B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C18.2239 11 18 11.2239 18 11.5C18 11.7761 18.2239 12 18.5 12H19.5C19.7761 12 20 11.7761 20 11.5C20 11.2239 19.7761 11 19.5 11H18.5Z",
    fill: "#00112B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5C15 14.2239 15.2239 14 15.5 14H16.5C16.7761 14 17 14.2239 17 14.5C17 14.7761 16.7761 15 16.5 15H15.5C15.2239 15 15 14.7761 15 14.5Z",
    fill: "#00112B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C15.2239 11 15 11.2239 15 11.5C15 11.7761 15.2239 12 15.5 12H16.5C16.7761 12 17 11.7761 17 11.5C17 11.2239 16.7761 11 16.5 11H15.5Z",
    fill: "#00112B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9C10.4477 9 10 9.44772 10 10V22C10 22.5523 10.4477 23 11 23H21C21.5523 23 22 22.5523 22 22V10C22 9.44772 21.5523 9 21 9H11ZM21 10H11V22H14V21C14 20.4477 14.4477 20 15 20H17C17.5523 20 18 20.4477 18 21V22H21V10Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.7810e98bca85035b3cee68dce1af7a05.svg";
export { ForwardRef as ReactComponent };